export default function ({ store, redirect }) {
  if (process.client && !store.getters["user/isLoggedIn"]) {
    return redirect("/login");
  }
}
